import './MenuGridPage.less';

export const prefix = 'bm-p-menu-grid';

export { default } from './MenuGridPage';
